import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import { getBasePath } from './utils/getBasePath';

i18n
    .use(HttpApi)
    .use(initReactI18next)
    .init({
        lng: 'es', // Disable if using a language detector
        supportedLngs: ['en', 'es'], // Add your supported languages here
        fallbackLng: 'es',
        detection: {
            order: ['cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
            caches: ['cookie'],
        },
        backend: {
            loadPath: `${getBasePath()}/locales/{{lng}}/translation.json`,
        },
        react: {
            useSuspense: false,
        },
    });

export default i18n;